



























































































































































import { Component, Vue } from 'vue-property-decorator';
import HexabaseState from '@/store/hexabase';
import AppState from '@/store/app';
import PortalModel from '@/models/portalModel';
import InformationPanel from '@/components/top/InformationPanel.vue';
import Header from '@/components/common/modules/Header.vue';
import SideMenu from '@/components/common/modules/SideMenu.vue';
import Pagination from '@/components/common/modules/Pagination.vue';
import SingleText from '@/components/common/elements/SingleText.vue';
import Button from '@/components/common/elements/Button.vue';
import Table from '@/components/common/elements/Table.vue';
import InputArea from '@/components/common/modules/InputArea.vue';
import SelectArea from '@/components/common/modules/SelectArea.vue';

import { DateTime } from 'luxon';

@Component({
  components: {
    Header,
    SideMenu,
    InformationPanel,
    SingleText,
    Button,
    Pagination,
    Table,
    InputArea,
    SelectArea
  }
})
export default class Portal extends Vue {
  private portal = new PortalModel();
  // 取得するデータレポートid
  private reportIds = { report1: 'r_selling_company' };
  // 表示するテーブルのカラム
  private baseListColumn = [
    { value: 'company_id', text: '組織', width: '200', align: 'center' },
    { value: 'service_type_id', text: 'サービス種別', width: '160', align: 'center' },
    { value: 'final_quote_commodity', text: '商材', width: '200', align: 'center' },
    { value: 'final_quotation_supplier', text: '仕入れ先', width: '200', align: 'center' },
    { value: 'project_name', text: '案件数', width: '80', align: 'right' },
    { value: 'final_estimated_selling_cost', text: '販売原価', width: '100', align: 'right' },
    { value: 'final_estimated_sales', text: '売上', width: '100', align: 'right' },
    { value: 'final_estimated_gross_profit', text: '粗利益', width: '100', align: 'right' },
    { value: 'project_status', text: '案件状況', width: '160', align: 'center' }
  ];
  // テーブル表示用に仕分する項目
  private baseListJournalItemNames = [
    'final_quotation_supplier',
    'project_name',
    'final_estimated_selling_cost',
    'final_estimated_sales',
    'final_estimated_gross_profit'
  ];
  // 小計、総合計の表示項目
  private totalBaseItemName = [
    { label: '案件数', isReadonly: true, value: 0, 'display_id': 'project_name' },
    { label: '販売原価', isReadonly: true, value: 0, 'display_id': 'final_estimated_selling_cost' },
    { label: '売上', isReadonly: true, value: 0, 'display_id': 'final_estimated_sales' },
    { label: '粗利益', isReadonly: true, value: 0, 'display_id': 'final_estimated_gross_profit' }
  ];
  // 売粗データレポート取得時に使用するパラメータ
  private getReportParams: any = {
    'use_display_id': true,
    'include_lookups': true,
    'per_page': 0,
    'page': 1,
    'conditions': [],
    'sort_fields': [
      {
        'id': 'service_type_id',
        'order': 'asc'
      }
    ]
  };
  private valueCheck = ['0', null];
  // 売粗データレポートから実績取得時に設定する検索条件
  private achievementConditions = [
    {
      'id': 'project_completion_date',
      'search_value': [],
      'include_null': false,
      'exact_match': true
    },
    {
      'id': 'final_estimated_selling_cost',
      'search_value': this.valueCheck,
      'include_null': false
    }
  ];
  // 売粗データレポートから予t理取得時に設定する検索条件
  private scheduleConditions = [
    {
      conditions: [
        {
          'id': 'expected_sales_month',
          'search_value': [],
          'exact_match': true
        },
        {
          'id': 'schedule_project_completion_date',
          'search_value': [],
          'exact_match': true
        }
      ],
      'use_or_condition': true // OR検索
    },
    {
      conditions: [
        {
          'id': 'project_completion_date',
          'search_value': [],
          'not_match': true,
          'include_null': false,
          'exact_match': true
        },
        {
          'id': 'project_completion_date',
          'search_value': [],
          'not_match': true,
          'include_null': false,
          'exact_match': true
        },
        {
          'id': 'final_estimated_selling_cost',
          'search_value': this.valueCheck,
          'include_null': false
        }
      ]
    }
  ];
  // 表のタイトル
  private reportName = '売粗：';
  private panelNames = ['実績＋予定', '実績', '予定'];
  // ページネーションに使用するベースとなる情報
  private basePageInfo = {
    'currentPage': 1,
    'totalPage': 1,
    'totalItem': 1,
    'visible': 8,
    'per_page': 10
  };
  private nowDate = DateTime.local();
  // 売粗の「実績＋予定」表示に関する情報をまとめたオブジェクト
  private achievementAndScheduleReportData: any = {
    panelName: this.panelNames[0],
    column: this.portal.deepCopy(this.baseListColumn),
    body: [],
    summaryData: [],
    totalDatas: [],
    pageInfo: this.portal.deepCopy(this.basePageInfo),
    selectAreaData: {
      selectValue: String(this.nowDate.year + '年' + this.nowDate.month + '月'),
      selectData: { name: '実績', options: [] }
    }
  };
  // 売粗の「実績」表示に関する情報をまとめたオブジェクト
  private achievementReportData: any = {
    panelName: this.panelNames[1],
    column: this.portal.deepCopy(this.baseListColumn),
    body: [],
    summaryData: [],
    totalDatas: [],
    pageInfo: this.portal.deepCopy(this.basePageInfo),
    selectAreaData: {
      selectValue: String(this.nowDate.year + '年' + this.nowDate.month + '月'),
      selectData: { name: '実績', options: [] }
    }
  };
  // 売粗の「予算」表示に関する情報をまとめたオブジェクト
  private scheduleReportData: any = {
    panelName: this.panelNames[2],
    column: this.portal.deepCopy(this.baseListColumn),
    body: [],
    summaryData: [],
    totalDatas: [],
    pageInfo: this.portal.deepCopy(this.basePageInfo),
    selectAreaData: {
      selectValue: String(this.nowDate.year + '年' + this.nowDate.month + '月'),
      selectData: { name: '予定', options: [] }
    }
  };
  // 各レポート表示に関する情報をまとめた配列
  private reportDatas: any = [
    this.achievementAndScheduleReportData,
    this.achievementReportData,
    this.scheduleReportData
  ];
  // 取得した売粗データレポートのデータが0件時の表示テキスト
  private tableNoDataText = 'データが存在しません';
  // 取得した売粗データレポートの配列位置(初期表示：InitialDisplay、実績：0、予定:1)
  private setDataType: any = { InitialDisplay: [0, 1, 2], 0: [0], 1: [1], 2: [2] };
  // 総合計、小計用の文言表示定数
  private setTotalTypeText = { total: '総合計', subTotal: '小計：' };

  // 画面開閉状態
  private switchButtonValue?: any = [true, true, true];
  // 開閉状態アイコン
  private switchButtonIcon?: any = ['mdi-menu-up', 'mdi-menu-up', 'mdi-menu-up'];

  /**
   * コンポーネントマウント時にパネルデータ生成
   */
  async mounted() {
    try {
      this.$store.commit('hexabase/setIsLoading', true);
      // 管理マスタに設定されている表示可能月の取得
      const managementMaster = AppState.options;
      const monthRange = managementMaster['ダッシュボード']['ダッシュボード'].displayable_months;
      // 実績側の表示年月選択取得
      let getSelectData = [];
      for (let i = 0; i < monthRange; i++) {
        const baseTIme: any = DateTime.local()
          .minus({ month: monthRange - (i + 1) })
          .startOf('month');
        getSelectData.push({
          value: String(baseTIme.year + '年' + baseTIme.month + '月'),
          text: String(baseTIme.year + '年' + baseTIme.month + '月'),
          data: baseTIme.c
        });
      }
      this.portal.deepCopy(getSelectData.reverse());
      this.achievementAndScheduleReportData.selectAreaData.selectData.options = getSelectData;
      this.achievementReportData.selectAreaData.selectData.options = getSelectData;

      // 予定側の表示年月選択取得
      getSelectData = [];
      for (let i = 0; i < monthRange * 2 + 1; i++) {
        const baseTIme: any = DateTime.local()
          .minus({ month: monthRange - i })
          .startOf('month');
        getSelectData.push({
          value: String(baseTIme.year + '年' + baseTIme.month + '月'),
          text: String(baseTIme.year + '年' + baseTIme.month + '月'),
          data: baseTIme.c
        });
      }
      this.scheduleReportData.selectAreaData.selectData.options = this.portal.deepCopy(
        getSelectData.reverse()
      );

      // 当月の期間取得(初期表示)
      const nowMonthStartDay = DateTime.local()
        .startOf('month')
        .toFormat('yyyy-MM-dd');
      const nowMonthEndDay = DateTime.local()
        .endOf('month')
        .toFormat('yyyy-MM-dd');
      const nowMonthToDay = DateTime.local().toFormat('yyyy-MM-dd');
      // 検索用のデフォルトパラメータを設定
      const achievementPayload = this.portal.deepCopy(this.getReportParams);
      const schedulePayload = this.portal.deepCopy(this.getReportParams);
      // 実績の検索日付を設定(案件完了日を通常条件)
      achievementPayload.conditions = this.portal.deepCopy(this.achievementConditions);
      // 実績：指定された月以前の案件完了しているデータを対象
      achievementPayload.conditions[0]['search_value'] = [nowMonthStartDay, nowMonthEndDay];
      // 予定の検索日付を設定(売上見込日を通常条件、案件完了日をNOT条件)
      schedulePayload.conditions = this.portal.deepCopy(this.scheduleConditions);
      // 予定：指定された売上予定月の範囲を対象
      schedulePayload.conditions[0].conditions[0]['search_value'] = [
        nowMonthStartDay,
        nowMonthEndDay
      ];
      // 予定：指定された案件完了日を対象
      schedulePayload.conditions[0].conditions[1]['search_value'] = [
        nowMonthStartDay,
        nowMonthEndDay
      ];
      // 予定：指定された月日以前の案件完了しているデータは対象外
      schedulePayload.conditions[1].conditions[0]['search_value'] = [null, nowMonthStartDay];
      // 指定された日付以降の案件完了しているデータは対象外
      schedulePayload.conditions[1].conditions[1]['search_value'] = [nowMonthToDay, null];
      await this.getSellingDataReport(
        [achievementPayload, schedulePayload],
        this.setDataType['InitialDisplay']
      );
    } catch (e) {
      this.setError(e);
    } finally {
      this.$store.commit('hexabase/setIsLoading', false);
    }
  }

  private commaAddition(totalDatas: any, summaryDatas: any, commodityTypeData: any) {
    // カンマ区切りの追加
    // 合計側
    for (const index in totalDatas) {
      for (const indexA in totalDatas[index].datas) {
        totalDatas[index].datas[indexA].value = String(
          totalDatas[index].datas[indexA].value.toLocaleString()
        );
      }
    }
    // 集計側
    for (const index in summaryDatas) {
      for (const indexA in summaryDatas[index].datas) {
        summaryDatas[index].datas[indexA].value = String(
          summaryDatas[index].datas[indexA].value.toLocaleString()
        );
      }
    }
    // 表側
    for (const index in commodityTypeData) {
      for (const property in commodityTypeData[index]) {
        if (commodityTypeData[index][property] !== undefined) {
          commodityTypeData[index][property] = String(
            commodityTypeData[index][property].toLocaleString()
          );
        } else {
          commodityTypeData[index][property] = '';
        }
      }
    }
  }

  private setReportData(reportData: any, setBaseData: any) {
    for (const index in setBaseData) {
      // 案件状況の設定
      if (
        setBaseData[index].project_completion_date === undefined ||
        setBaseData[index].project_completion_date === ''
      ) {
        setBaseData[index]['project_status'] = '工事完了予定';
      } else {
        setBaseData[index]['project_status'] = '工事完了';
      }
    }

    const commodityTypeData: any = Array.from(
      new Map(
        this.portal.deepCopy(setBaseData).map((item: any) => [item.final_quote_commodity, item])
      ).values()
    );
    this.setCommodityTypeData(setBaseData, commodityTypeData);

    const serviceTypeData: any = Array.from(
      new Map(
        this.portal.deepCopy(setBaseData).map((item: any) => [item.service_type_id, item])
      ).values()
    );
    const summaryDatas: any = [];
    this.setSummaryDatas(summaryDatas, serviceTypeData, commodityTypeData);

    const totalData: any = {
      label: this.setTotalTypeText.total,
      datas: this.portal.deepCopy(this.totalBaseItemName)
    };
    this.setTotalData(totalData, summaryDatas);

    this.commaAddition([totalData], summaryDatas, commodityTypeData);
    // 表への設定
    reportData.body = commodityTypeData;
    reportData.summaryDatas = summaryDatas;
    reportData.totalDatas = [totalData];
    reportData.pageInfo = this.portal.deepCopy(this.basePageInfo);
    reportData.pageInfo.totalItem = commodityTypeData.length;
    reportData.pageInfo.totalPage = Math.ceil(
      commodityTypeData.length / reportData.pageInfo.per_page
    );
  }

  /**
   * データレポート取得し、取得した内容を表示用に整形
   * @param {any} payloads データレポート取得用ペイロード
   * @param {any} setDataType 設定する項目情報
   */
  async getSellingDataReport(payloads: any, setDataType: any) {
    const addPromises: any = [];
    // payloadsの配列数分、設定を行う
    for (const index in payloads) {
      addPromises.push(
        this.portal.getReports(HexabaseState.applicationId, this.reportIds.report1, payloads[index])
      );
    }
    // データレポート取得をパラレルで実行
    const responseData: any = await Promise.all(addPromises);

    for (const index in setDataType) {
      switch (setDataType[index]) {
        case 0: {
          const data: any = {};
          const data2: any = {};
          const data3: any = {};
          this.setReportData(data, responseData[0]['report_results']);
          this.setReportData(data2, responseData[1]['report_results']);
          this.setReportData(
            data3,
            this.portal.deepCopy(
              responseData[1]['report_results'].concat(responseData[0]['report_results'])
            )
          );
          // 表示に必要なデータを設定
          this.reportDatas[setDataType[index]].body = data.body.concat(data2.body);
          this.reportDatas[setDataType[index]].summaryDatas = data3.summaryDatas;
          this.reportDatas[setDataType[index]].totalDatas = data3.totalDatas;
          break;
        }
        case 1: {
          this.setReportData(
            this.reportDatas[setDataType[index]],
            responseData[0]['report_results']
          );
          break;
        }
        case 2: {
          const dataIndex = setDataType.length === 1 ? 0 : 1;
          this.setReportData(
            this.reportDatas[setDataType[index]],
            responseData[dataIndex]['report_results']
          );
          break;
        }
        default:
          break;
      }
    }
  }

  /**
   * サービス種別、商材毎に各項目を集計
   * @param {number} panelIndex パネルに割り振られたインデックス番号
   * @param {any} tableData 選択されたテーブルデータ
   */
  private changeSelectMonthlyAction(event: any, tableData: any, panelIndex: number) {
    tableData.selectAreaData.selectValue = event.value;
    this.getMonthlyDataAction(panelIndex, tableData);
  }

  async getMonthlyDataAction(panelIndex: number, tableData: any) {
    try {
      this.$store.commit('hexabase/setIsLoading', true);
      // 選択された表示年月のデータを検索
      const findData = tableData.selectAreaData.selectData.options.find((item: any) => {
        if (tableData.selectAreaData.selectValue === item.value) {
          return item;
        }
      });
      // 取得する日時の月初、月末を取得
      // 当月かのチェック
      const baseDate = DateTime.local();
      let getMonthStartDay = '';
      let getMonthEndDay = '';
      if (baseDate.month === findData.data.month) {
        getMonthStartDay = baseDate.startOf('month').toFormat('yyyy-MM-dd');
        getMonthEndDay = baseDate.endOf('month').toFormat('yyyy-MM-dd');
      } else {
        getMonthStartDay = String(
          DateTime.local(findData.data.year, findData.data.month, findData.data.day).toFormat(
            'yyyy-MM-dd'
          )
        );
        getMonthEndDay = String(
          DateTime.local(findData.data.year, findData.data.month, findData.data.day)
            .endOf('month')
            .toFormat('yyyy-MM-dd')
        );
      }
      // 検索用のデフォルトパラメータを設定
      const achievementPayload = this.portal.deepCopy(this.getReportParams);
      const schedulePayload = this.portal.deepCopy(this.getReportParams);
      achievementPayload.conditions = this.portal.deepCopy(this.achievementConditions);
      schedulePayload.conditions = this.portal.deepCopy(this.scheduleConditions);
      // 実績の検索日付を設定(案件完了日を通常条件)
      achievementPayload.conditions[0]['search_value'] = [getMonthStartDay, getMonthEndDay];
      // 予定：指定された売上予定月の範囲を対象
      schedulePayload.conditions[0].conditions[0]['search_value'] = [
        getMonthStartDay,
        getMonthEndDay
      ];
      // 予定：指定された案件完了日を対象
      schedulePayload.conditions[0].conditions[1]['search_value'] = [
        getMonthStartDay,
        getMonthEndDay
      ];
      // 予定：指定された月日以前の案件完了しているデータは対象外
      schedulePayload.conditions[1].conditions[0]['search_value'] = [null, getMonthStartDay];
      // 指定された日付以降の案件完了しているデータは対象外
      schedulePayload.conditions[1].conditions[1]['search_value'] = [getMonthStartDay, null];

      // セレクトエリアを操舵しているパネルのテーブル内容を更新
      switch (tableData.panelName) {
        case this.panelNames[0]: {
          // 実績+予定
          await this.getSellingDataReport(
            [achievementPayload, schedulePayload],
            this.setDataType[panelIndex]
          );
          break;
        }
        case this.panelNames[1]: {
          // 実績
          await this.getSellingDataReport([achievementPayload], this.setDataType[panelIndex]);
          break;
        }
        case this.panelNames[2]: {
          // 予定
          await this.getSellingDataReport([schedulePayload], this.setDataType[panelIndex]);
          break;
        }
        default: {
          break;
        }
      }
    } catch (e) {
      this.setError(e);
    } finally {
      this.$store.commit('hexabase/setIsLoading', false);
    }
  }

  /**
   * サービス種別、商材毎に各項目を集計
   * @param {any} setData 表示用データ
   * @param {any} commodityTypeData 集計用データ
   */
  private setCommodityTypeData(setData: any, commodityTypeData: any) {
    for (const indexA in commodityTypeData) {
      for (const baseIndex in this.baseListJournalItemNames) {
        const JournalItemName = this.baseListJournalItemNames[baseIndex];
        switch (JournalItemName) {
          case 'final_quotation_supplier': {
            commodityTypeData[indexA][JournalItemName] = '';
            break;
          }
          default: {
            commodityTypeData[indexA][JournalItemName] = 0;
            break;
          }
        }
      }

      for (const indexB in setData) {
        if (
          setData[indexB].final_quote_commodity === commodityTypeData[indexA].final_quote_commodity
        ) {
          for (const baseIndex in this.baseListJournalItemNames) {
            const JournalItemName = this.baseListJournalItemNames[baseIndex];
            switch (JournalItemName) {
              case 'final_quotation_supplier': {
                commodityTypeData[indexA][JournalItemName] = setData[indexB][JournalItemName];
                break;
              }
              case 'project_name': {
                commodityTypeData[indexA][JournalItemName] += 1;
                break;
              }
              default: {
                commodityTypeData[indexA][JournalItemName] += setData[indexB][JournalItemName];
                break;
              }
            }
          }
        }
      }
    }
  }

  /**
   * 小計のサービス種別名の設定と各項目を集計
   * @param {any} summaryDatas 表示用データ
   * @param {any} serviceTypeData サービス種別判別、設定用データ
   * @param {any} commodityTypeData 集計用データ
   */
  private setSummaryDatas(summaryDatas: any, serviceTypeData: any, commodityTypeData: any) {
    for (const index in serviceTypeData) {
      summaryDatas[index] = {
        label: this.setTotalTypeText.subTotal + serviceTypeData[index].service_type_id,
        datas: this.portal.deepCopy(this.totalBaseItemName)
      };
      for (const setIndex in commodityTypeData) {
        if (
          serviceTypeData[index].service_type_id === commodityTypeData[setIndex].service_type_id
        ) {
          for (const setIndexB in summaryDatas[index].datas) {
            summaryDatas[index]['datas'][setIndexB].value +=
              commodityTypeData[setIndex][summaryDatas[index].datas[setIndexB]['display_id']];
          }
        }
      }
    }
  }

  /**
   * 集計データから総合計の各項目を集計
   * @param {any} setTotalData 表示用データ
   * @param {any} pageInfo 集計用データ
   */
  private setTotalData(totalData: any, summaryDatas: any) {
    for (const index in summaryDatas) {
      for (const setIndexB in totalData.datas) {
        totalData.datas[setIndexB].value += summaryDatas[index].datas[setIndexB].value;
      }
    }
  }

  /**
   * ページ情報からページネーション内のテキスト情報を更新
   * @param {any} pageInfo ページ情報
   * @return {void}
   */
  private createPaginationTxt(pageInfo: any): string | null {
    if (pageInfo['totalItem'] === 0) return null;
    const initialNum = 1;
    const start =
      pageInfo['currentPage'] > initialNum
        ? (pageInfo['currentPage'] - initialNum) * pageInfo['per_page'] + initialNum
        : initialNum;
    let end = pageInfo['currentPage'] * pageInfo['per_page'];
    if (end > pageInfo['totalItem']) {
      end = pageInfo['totalItem'];
    }
    return `全${pageInfo['totalItem']}件中 ${start}件〜${end}件を表⽰`;
  }

  /**
   * ページネーションで選択された番号をテーブルデータに設定
   * @param {number} pageNum ページ番号
   * @return {void}
   */
  private pagenaviAction(pageNum: number, reportData: any) {
    reportData.pageInfo.currentPage = pageNum;
  }

  /**
   * エラー文言を表示
   * @param {number} errorMessage エラーメッセージ
   */
  private setError(errorMessage: any): void {
    if (typeof errorMessage === 'object') errorMessage = this.portal.getDefaultErrorMessage();
    // エラーをキャッチした際共通エラーダイアログにセット
    this.$store.commit('hexabase/setIsError', true);
    this.$store.commit('hexabase/setErrorMessage', errorMessage);
  }

  /**
   * 詳細の表示・非表示切替
   * @param {boolean} flag フラグ
   * @param {number} index 選択したパネルのインデックス番号
   */
  private showDetailInformation(flag: boolean, index: number) {
    if (this.switchButtonValue[index] === true) {
      this.$set(this.switchButtonValue, index, false);
      this.$set(this.switchButtonIcon, index, 'mdi-menu-down');
    } else {
      this.$set(this.switchButtonValue, index, true);
      this.$set(this.switchButtonIcon, index, 'mdi-menu-up');
    }
  }
}
